import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SetupService } from '@core/services/setup';

@Component({
    selector: 'app-not-found',
    styleUrls: ['./not-found.component.scss'],
    templateUrl: './not-found.component.html',
})
export class NotFoundComponent implements OnInit {
    constructor(private title: Title, private setupService: SetupService) {}

    ngOnInit(): void {
        this.title.setTitle(this.setupService.title);
    }
}
